module.exports = __webpack_public_path__ + "static/media/YM78_5.27aacc9d.jpg";